import ErrorFormatService from '../../services/error-format-service';
import {
  DELETE_CONTACT_COMMENT_SUCCESS, SAVE_CONTACT_COMMENT_SUCCESS, GET_CONTACT_DATA_SUCCESS, SAVE_CONTACT_DATA,
  SAVE_CONTACT_DATA_SUCCESS, SAVE_CONTACT_DATA_ERROR, GET_CONTACT_USER_DATA_SUCCESS, RESET_CONTACT_DATA,
  RESET_CONTACT_USER_DATA, RESET_CONTACT_VCARD_DATA, SAVE_CONTACT_COMMENT, LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS,
  GET_LIST_CONTACT_COMPANY_DATA_SUCCESS, GET_LIST_CONTACT_PERSON_DATA_SUCCESS, GET_LIST_NOT_LINKED_USER_DATA_SUCCESS,
  RESET_FORM_ERRORS, GET_CONTACT_VCARD_DATA_SUCCESS, GET_LIST_TAG_DATA_SUCCESS, GET_CONTACT_RELATED_CONTACT_LIST_DATA,
  GET_CONTACT_RELATED_CONTACT_LIST_DATA_SUCCESS, GET_CONTACT_RELATED_CONTACT_LIST_DATA_ERROR,
  GET_CONTACT_DEAL_LIST_DATA, GET_CONTACT_DEAL_LIST_DATA_SUCCESS, GET_CONTACT_DEAL_LIST_DATA_ERROR,
} from '../../constants/system/actions';

const contactReducer: Reducer = (
  state: ReducerState = {
    contactData: null,
    formErrors: {},
    isFormSaving: false,
    isCommentSaving: false,
    isRelatedContactListLoading: false,
    isContactDealListLoading: false,
    contactVCardFile: null,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_CONTACT_DATA_SUCCESS:
      return {
        ...state,
        contactData: action.data,
      };
    case GET_CONTACT_USER_DATA_SUCCESS:
      return {
        ...state,
        contactData: {
          ...state.contactData,
          contactUser: action.data,
        },
      };
    case GET_CONTACT_VCARD_DATA_SUCCESS:
      return {
        ...state,
        contactVCardFile: action.data.file,
        formErrors: {},
        isFormSaving: false,
      };
    case GET_CONTACT_RELATED_CONTACT_LIST_DATA:
      return {
        ...state,
        isRelatedContactListLoading: true,
      };
    case GET_CONTACT_RELATED_CONTACT_LIST_DATA_SUCCESS:
      return {
        ...state,
        contactData: {
          ...state.contactData,
          relatedContactList: [...state.contactData.relatedContactList, ...action.data],
        },
        isRelatedContactListLoading: false,
      };
    case GET_CONTACT_RELATED_CONTACT_LIST_DATA_ERROR:
      return {
        ...state,
        isRelatedContactListLoading: false,
      };
    case GET_CONTACT_DEAL_LIST_DATA:
      return {
        ...state,
        isContactDealListLoading: true,
      };
    case GET_CONTACT_DEAL_LIST_DATA_SUCCESS:
      return {
        ...state,
        contactData: {
          ...state.contactData,
          contactDealList: [...state.contactData.contactDealList, ...action.data],
        },
        isContactDealListLoading: false,
      };
    case GET_CONTACT_DEAL_LIST_DATA_ERROR:
      return {
        ...state,
        isContactDealListLoading: false,
      };
    case SAVE_CONTACT_DATA:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case SAVE_CONTACT_DATA_SUCCESS:
      return {
        ...state,
        contactData: action.data.contactData,
        formErrors: {},
        isFormSaving: false,
      };
    case SAVE_CONTACT_DATA_ERROR:
      if (!action.error) {
        return {
          ...state,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: ErrorFormatService.isFormError(action.error)
          ? ErrorFormatService.formatGraphQLErrors({ ...action.error })
          : ErrorFormatService.formatGraphQLMainError({ ...action.error }),
        isFormSaving: false,
      };
    case SAVE_CONTACT_COMMENT:
      return {
        ...state,
        isCommentSaving: true,
      };
    case DELETE_CONTACT_COMMENT_SUCCESS:
    case SAVE_CONTACT_COMMENT_SUCCESS:
      if (state.contactData) {
        return {
          ...state,
          isCommentSaving: false,
          contactData: {
            ...state.contactData,
            contact: {
              ...state.contactData.contact,
              comments: action.data.comments,
              attachments: action.data.attachments,
            },
          },
        };
      }

      return state;
    case GET_LIST_CONTACT_COMPANY_DATA_SUCCESS:
      if (!state.contactData) {
        return state;
      }

      return {
        ...state,
        contactData: {
          ...state.contactData,
          contactCompanyList: action.data,
        },
      };
    case GET_LIST_CONTACT_PERSON_DATA_SUCCESS:
      if (!state.contactData) {
        return state;
      }

      return {
        ...state,
        contactData: {
          ...state.contactData,
          contactPersonList: action.data,
        },
      };
    case GET_LIST_NOT_LINKED_USER_DATA_SUCCESS:
      if (!state.contactData) {
        return state;
      }

      return {
        ...state,
        contactData: {
          ...state.contactData,
          notLinkedUserList: action.data,
        },
      };
    case GET_LIST_TAG_DATA_SUCCESS:
      if (!state.contactData) {
        return state;
      }

      return {
        ...state,
        contactData: {
          ...state.contactData,
          tagList: action.data,
        },
      };
    case RESET_CONTACT_DATA:
      return {
        ...state,
        contactData: null,
        formErrors: {},
        isFormSaving: false,
        contactVCardFile: null,
      };
    case RESET_CONTACT_USER_DATA:
      return {
        ...state,
        contactData: {
          ...state.contactData,
          contactUser: null,
        },
      };
    case RESET_CONTACT_VCARD_DATA:
      return {
        ...state,
        contactVCardFile: null,
      };
    case RESET_FORM_ERRORS:
      return {
        ...state,
        formErrors: {},
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        contactData: null,
        formErrors: {},
        isFormSaving: false,
        isCommentSaving: false,
        contactVCardFile: null,
      };
    default:
      return state;
  }
};

export default contactReducer;
